// @flow
import React from 'react';

// Material
import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';

// Custom
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import {
  Card,
  CardBody,
  CardFooter,
  CardLabel,
  CardTitle,
  CardPrice,
} from './components';

const useStyles = makeStyles(theme => ({
  listIcon: {
    marginRight: theme.spacing(2),
  },
}));

type PricingCardProps = {
  station: string,
  ticketType: string,
  label: string,
  price: string,
  benefits: Array<string>,
  renderIcon: Function,
};

const PricingCard = ({
  station,
  ticketType,
  label,
  price,
  benefits,
  renderIcon,
}: PricingCardProps) => {
  const classes = useStyles();

  return (
    <Card>
      <CardBody>
        {renderIcon()}
        <CardTitle>{station.toUpperCase()}</CardTitle>
        <CardPrice>¥{price}</CardPrice> /adult
        <CardLabel>{label}</CardLabel>
        <List dense={true}>
          {benefits.map((benefit, i) => {
            return (
              <ListItem key={i}>
                <CheckIcon className={classes.listIcon} />
                <ListItemText primary={benefit} />
              </ListItem>
            );
          })}
        </List>
      </CardBody>
      <CardFooter />
    </Card>
  );
};

export default PricingCard;
